__webpack_require__.p = "https://www.aws-geek.com/";